export default "__VITE_ASSET__C0KhXshU__$_?nuxt_component=async&nuxt_component_name=SvgoLinksHeader&nuxt_component_export=default__"